import envConfig from '@envConfig';

/**
 * アプリ共通設定
 */
const appConfig = {

  /** システム名 */
  sysTitle: '共架・管路申請管理システム',

  /** 著作権表示 */
  copyright: 'Copyright © NEC Corporation 2025. All rights reserved.',

  /** 認証状態ヘッダー名 */
  authHeader: 'X-Nec-Authorized',

  /** 運用状態ヘッダー名 */
  statHeader: 'X-Nec-Run-Status',

  /** 地図設定 */
  gis: {

    /** ArcGIS APIキー */
    apiKey: 'AAPTxy8BH1VEsoebNVZXo8HurAsmwCLnUooIH2rTH5IP6w_1cNq0rm1vnmhhQ31I-kKhqnlCliJFxcg3iWfvOQfF2FDbPLGCmfG4V2P9JiNVpOIoTSONrlImGcaSSkuoKhPY3ui1xShfrD9aIYTBDuJNRKp3-PXEfk7tdvaf01lmCI5nIHY1foFQiHyZV3d7B-AoB72zMMHzgc5g7z-wPBGopnzEGTvdXgOmoyP5oTwCknXfMkryc9pnOoyAR9wz5w32AT1_7X2L0pYj',

    /** 電柱マスタレイヤーID */
    masterLayer: '132816f0ccd645cfb8e4f52e25001cce',
  },
};

/**
 * スタイル設定
 */
const uiConfig = {
  sidebarWidth: 220,   // サイドバーの幅
  headerHeight: 48,    // ヘッダーの高さ (サイドバーの上パディング)
};

// アプリ環境設定をマージ
export default {
  ui: uiConfig,
  ...appConfig,
  ...envConfig,
};
